import { useContext } from "react";
import Filter, { FilterProps } from "./Filter";
import { FilterTagsProps } from "./FilterTags";
import FilterContext from "./FilterContext";

export type FilterItemProps = Omit<
  FilterProps,
  keyof Omit<FilterTagsProps, "items" | "sections" | "children">
>;

const FilterItem = ({ ...props }: FilterItemProps) => {
  const { isGrouped } = useContext(FilterContext);

  return <Filter {...props} hiddenTags={isGrouped} />;
};

export default FilterItem;
